<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet"
            type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
            type="text/css"/>

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css"
            rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

    </head>

    <body @contextmenu.prevent data-sidebar="dark">

    <!-- Begin page -->
    <div id="layout-wrapper">

      <NavigationBar/>

      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div id="content" class="content-minimize">

        <div class="page-content">
          <div class="container-fluid">

            <!-- start page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">Departmental HR Monthly Report</h4>

                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                      <li class="breadcrumb-item active">Payroll Reconciliation </li>
                        <li class="breadcrumb-item active">Recon History </li>
                    </ol>
                  </div>

                </div>
              </div>
            </div>
            <!-- end page title -->

            <!-- stats cards -->
            <!-- stats cards -->
            <div class="row">

              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <div class="input-group fw-semibold text-uppercase me-3">
                      <label class="input-group-text text-uppercase fw-bold bg-primary text-white">Select Month</label>
                      <select id="month-select" class="form-select" style="width: 200px;">
                        <option selected="selected" value="">Select Month</option>
                        <option value="01">January</option>
                        <option value="02">February</option>
                        <option value="03">March</option>
                        <option value="04">April</option>
                        <option value="05">May</option>
                        <option value="06">June</option>
                        <option value="07">July</option>
                        <option value="08">August</option>
                        <option value="09">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Last Month Uploaded</p>
                        <h5 id="lastMonthUploaded" class="mb-0 text-danger">No</h5>
                        <p class="text-muted small">Disclaimer: Data may be incomplete</p>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                          <i class="mdi mdi-alert-circle"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Discrepancies Detected</p>
                        <h5 id="discrepancies" class="mb-0">15</h5>
                        <p class="text-muted small">Last Month: <span id="lastDiscrepancies">10</span></p>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                          <i class="mdi mdi-alert"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Employee Count</p>
                        <h5 id="employeeCount" class="mb-0 text-danger">7,720</h5>
                        <p class="text-muted small">Last Upload: <span id="lastEmployeeCount">500</span></p>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-info rounded-circle text-white font-size-20">
                          <i class="mdi mdi-account-group"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Wage Bill</p>
                        <h5 id="wageBill" class="mb-0 text-danger">Ksh   15,000,000</h5>
                        <p class="text-muted small">Last Month: <span id="lastWageBill">Ksh   14,500,000</span></p>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                          <i class="mdi mdi-cash-multiple"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>


            <!-- end of stats -->
            <div class="row">
              <div class="col-12">
                <div class="card">

                  <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                    <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                      <div class="flex-grow-1">
                        <div class="search-box mb-0 me-3">
                          <div class="position-relative">
                            <input type="text" class="form-control bg-light border-light rounded" placeholder="Search..." fdprocessedid="husj3l" spellcheck="false" data-ms-editor="true">
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex">
                        <div class="d-flex align-items-center me-3 pe-3">
                          <div>
                            <div class="float-end d-flex ">
                              <div class="input-group fw-semibold text-uppercase me-3">
                                <label class="input-group-text text-uppercase">Department</label>
                                <select class="form-select " style="width: 200px;">
                                  <option selected="selected" value="">All Departments</option>
                                  <option value="65">Finance &amp; Economic Planning</option>
                                  <option value="67">Governance, Administration, Communication &amp; Devolution</option>
                                  <option value="73">Education, Human Capital Development &amp; Vocational Training</option>
                                  <option value="62">Blue Economy, Fisheries, Mining &amp; Digital Economy</option>
                                  <option value="66">Roads, Public Works, Transport &amp; Infrastructure</option>
                                  <option value="61">Youth, Sports, Talent Development, Gender Inclusivity, Cultural Heritage &amp; Social Services</option>
                                  <option value="63">Water, Irrigation, Sanitation, Environment, Energy, Forestry &amp; Climate Change</option>
                                  <option value="68">Public Health &amp; Medical Services</option>
                                  <option value="64">Lands, Physical Planning, Housing &amp; Urban Development</option>
                                  <option value="69">Trade, Industry, Tourism, Co-Operative Development and Marketing</option>
                                  <option value="70">Agriculture and Livestock Production</option>
                                  <option value="72">Office of the County Secretary and Head of Public Service</option>
                                </select>
                              </div>





                            </div>
                          </div>
                        </div>
                        <button data-bs-toggle="modal" data-bs-target=".download-modal" type="button" class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize">
                          <i class="bx bxs-download "></i> <span class="pl-1 d-md-inline">Download Report</span>
                        </button>

                        <!-- Add Asset Button -->






                      </div>


                    </div>
                    <div class="btn-toolbar p-3 align-items-center d-none animated delete-tool-bar" role="toolbar">
                      <button type="button" data-bs-toggle="modal" data-bs-target=".download-modal" class="btn btn-primary waves-effect btn-label waves-light me-3"><i class="mdi mdi-printer label-icon"></i> Print Selected Invoices</button>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table align-middle table-hover contacts-table table-striped text-nowrap" id="datatable-buttons">
                        <thead class="table-light">
                        <tr class="table-dark">
                          <th scope="col">Date Uploaded</th>
                          <th scope="col">Month For</th>
                          <th scope="col">Total Payroll Records</th>
                          <th scope="col">Payroll Wage Bill</th>
                          <th scope="col">Employee Records</th>
                          <th scope="col">Employee Wage Bill</th>
                          <th scope="col">Employee Discrepancy Records</th>
                          <th scope="col">Wage Bill Discrepancies</th>
                          <th scope="col">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td>12 Feb 2025</td> <!-- Date Uploaded -->
                          <td>February 2025</td> <!-- Month For -->
                          <td>7,750</td> <!-- Total Payroll Records (Adjusted) -->
                          <td>Ksh 50,000 (104.17%)</td> <!-- Payroll Wage Bill with Percentage -->
                          <td>7,720</td> <!-- Employee Records -->
                          <td>Ksh 48,000</td> <!-- Employee Wage Bill -->
                          <td>10</td> <!-- Employee Discrepancy Records -->
                          <td>Ksh 2,000</td> <!-- Wage Bill Discrepancies -->
                          <td>
                            <button @click="gotTo('view_discrepancy')" class="btn btn-primary btn-sm">
                              View Discrepancy
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td>25 Apr 2023</td> <!-- Date Uploaded -->
                          <td>April 2023</td> <!-- Month For -->
                          <td>7,760</td> <!-- Total Payroll Records (Adjusted) -->
                          <td>Ksh 60,000 (103.45%)</td> <!-- Payroll Wage Bill with Percentage -->
                          <td>7,720</td> <!-- Employee Records -->
                          <td>Ksh 58,000</td> <!-- Employee Wage Bill -->
                          <td>10</td> <!-- Employee Discrepancy Records -->
                          <td>Ksh 2,000</td> <!-- Wage Bill Discrepancies -->
                          <td>
                            <button class="btn btn-primary btn-sm" onclick="window.location.href='view_discrepancy.html'">
                              View Discrepancy
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td>15 Jun 2021</td> <!-- Date Uploaded -->
                          <td>June 2021</td> <!-- Month For -->
                          <td>7,740</td> <!-- Total Payroll Records (Adjusted) -->
                          <td>Ksh 55,000 (103.77%)</td> <!-- Payroll Wage Bill with Percentage -->
                          <td>7,720</td> <!-- Employee Records -->
                          <td>Ksh 53,000</td> <!-- Employee Wage Bill -->
                          <td>10</td> <!-- Employee Discrepancy Records -->
                          <td>Ksh 2,000</td> <!-- Wage Bill Discrepancies -->
                          <td>
                            <button class="btn btn-primary btn-sm" onclick="window.location.href='view_discrepancy.html'">
                              View Discrepancy
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td>10 Sep 2022</td> <!-- Date Uploaded -->
                          <td>September 2022</td> <!-- Month For -->
                          <td>7,780</td> <!-- Total Payroll Records (Adjusted) -->
                          <td>Ksh 70,000 (102.94%)</td> <!-- Payroll Wage Bill with Percentage -->
                          <td>7,720</td> <!-- Employee Records -->
                          <td>Ksh 68,000</td> <!-- Employee Wage Bill -->
                          <td>10</td> <!-- Employee Discrepancy Records -->
                          <td>Ksh 2,000</td> <!-- Wage Bill Discrepancies -->
                          <td>
                            <button class="btn btn-primary btn-sm" onclick="window.location.href='view_discrepancy.html'">
                              View Discrepancy
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td>5 Dec 2023</td> <!-- Date Uploaded -->
                          <td>December 2023</td> <!-- Month For -->
                          <td>7,790</td> <!-- Total Payroll Records (Adjusted) -->
                          <td>Ksh 80,000 (102.56%)</td> <!-- Payroll Wage Bill with Percentage -->
                          <td>7,720</td> <!-- Employee Records -->
                          <td>Ksh 78,000</td> <!-- Employee Wage Bill -->
                          <td>10</td> <!-- Employee Discrepancy Records -->
                          <td>Ksh 2,000</td> <!-- Wage Bill Discrepancies -->
                          <td>
                            <button class="btn btn-primary btn-sm" onclick="window.location.href='view_discrepancy.html'">
                              View Discrepancy
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>
              </div>
              <!-- end col -->
            </div>

            <!-- end row -->
          </div>
          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

      </div>
      <!-- end main content-->

    </div>
    <!-- END layout-wrapper -->

    </body>

  </div>
</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, executeDownload, getRight, trade} from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import router from "@/router";

import moment from "moment";

export default {
  name: "LoginPage",
  components: { NavigationBar},
  data() {
    return {
      download:'Download',
      search:'',
      loading: false,
      // set the initial current page as 1
      currentPage: 1,
      // set the total number of pages as 10 (you can change this according to your data source)
      totalPages: 0,
      // set the number of items per page as 5 (you can change this according to your preference)
      pageSize: 10,
      summary: {
        count: 0,
        total: 0
      },


    }

  },

  computed: {
    //pagination code
    // calculate the start index of the items for the current page
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    // calculate the end index of the items for the current page
    endIndex() {
      return this.currentPage * this.pageSize;
    },

    totalReceiptAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.receiptAmount), 0));
    }, totalBillBalance() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.billBalance), 0));
    },
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.detailAmount), 0));
    }

  },
  mounted() {
    async function fetchPayrollData() {
      try {
        const response = await fetch('your-api-endpoint');
        const data = await response.json();

        document.getElementById('lastMonthUploaded').textContent = data.lastMonthUploaded ? 'Yes' : 'No';
        document.getElementById('discrepancies').textContent = data.discrepancies;
        document.getElementById('lastDiscrepancies').textContent = data.lastDiscrepancies;
        document.getElementById('employeeCount').textContent = data.employeeCount;
        document.getElementById('lastEmployeeCount').textContent = data.lastEmployeeCount;
        document.getElementById('wageBill').textContent = data.wageBill + '%';
        document.getElementById('lastWageBill').textContent = data.lastWageBill + '%';
      } catch (error) {
        console.error('Error fetching payroll data:', error);
      }
    }

    fetchPayrollData();
  },
  methods: {
    gotTo(route) {
      router.push(route)
    },

  }
}
</script>

